import { PaymentTermsGroup } from '../constants/payment-terms-group.js';
// WHY: COD (net_days = 0) is a single term, not a group -- it has no group id, so callers address
// it by its own paymentTermsId (see isCodTerm below). Everything else, including NULL (e.g.
// Consignment), is NET.
export function paymentTermsGroupFor(netDays) {
    return netDays === 0 ? null : PaymentTermsGroup.NET;
}
/** True for the one payment term COD identifies as (net_days = 0) -- the term this app resolves
 *  at runtime via `net_days = 0 AND active_flag`, never a hardcoded id (see
 *  build-price-sheet-nodes.ts's `findCodPaymentTermsId`). */
export function isCodTerm(netDays) {
    return netDays === 0;
}
//# sourceMappingURL=payment-terms-group-for.js.map